var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},[_c('Banner',{attrs:{"bannerImage":"bannerEquipe","hasAvatar":"0"}}),_c('TabMenu',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Tab',{attrs:{"text":"Utilisateurs","route":"/equipe/utilisateurs"}})]},proxy:true}])}),_c('div',{staticClass:"page-main-container"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }